export function formatCardNumber(recordId: number): string {
    return `№ ${String(recordId).padStart(6, '0')}`;
}
